var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (
    _vm.$route.name !== 'Seat Layout' &&
      _vm.$route.name !== 'Food and Drinks Checkout' &&
      _vm.$route.name !== 'Booking Summary' &&
      _vm.$route.name !== 'Final Ticket' &&
      _vm.$route.name !== 'Regular Booking' &&
      _vm.$route.name !== 'Pay Now' &&
      _vm.$route.name !== 'Home Page'
  )?_c('section',{staticClass:"sticky-top"},[_c('div',{staticClass:"d-flex align-items-center py-3 bg-dark text-white px-3"},[_c('div',[_c('img',{attrs:{"src":require("@/assets/img/icons/back-arrow.svg"),"alt":""},on:{"click":function($event){return _vm.$router.go(-1)}}})]),_vm._v(" "),_c('div',{staticClass:"flex-grow-1 text-center"},[_vm._v(_vm._s(_vm.routerName))])])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c88c9902","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/partials/mobileHeader.vue
// module id = null
// module chunks = 